import slugify from 'slugify';

export const SLUG_SEPARATOR = '_';

/**
 * Converts input to a URL-safe slug
 * @param {string} title - the title of the post
 * @returns {string} a URL-safe slug based on the post's title
 */
export const titleAndIdToSlug = (title: string, id: string) => {
  // limit the title to 25 characters
  const limitedTitle = title.slice(0, 50);

  const uriSlug = slugify(limitedTitle, {
    lower: true, // convert everything to lower case
    trim: true, // remove leading and trailing spaces
    strict: true, // remove special characters
    remove: /[*+~.()'"!:@]/g, // remove special characters
  });

  // encode special characters like spaces and quotes to be URL-safe
  return encodeURI(`${uriSlug}${SLUG_SEPARATOR}${id}`);
};

// given any slug, try to extract an id from it
// if there is no seperator just return the slug
export const getIdFromSlug = (slug: string) => {
  const parts = slug?.split(SLUG_SEPARATOR);
  return parts?.length > 1 ? parts.pop() : slug;
};

interface ReviewForSlug {
  id: string;
  food?: {
    name: string;
  };
  place?: {
    name: string;
  };
  reviewText: string; // Should be the original, untranslated text
}

export const generateReviewSlug = (review: ReviewForSlug): string => {
  const titleText = `${review.food?.name || ''}-${review.place?.name?.slice(0, 10) || ''}-${review.reviewText?.slice(0, 50) || ''}`;
  return titleAndIdToSlug(titleText, review.id);
};
